module.exports = __webpack_public_path__ + "img/money.066d82a2.svg";